import React from 'react';
import { Button, Tooltip } from '@material-ui/core/';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

function ProductLowesBtn({ pdUrl, text = 'Lowes.com' }) {
	const titleMsg = 'view this product on Lowes.com';
	return (
		<Tooltip title={titleMsg} arrow={true} placement="top">
			<span>
				<Button
					startIcon={<OpenInNewIcon color="primary" />}
					color="primary"
					onClick={() => window.open(pdUrl)}
				></Button>
			</span>
		</Tooltip>
	);
}

export default ProductLowesBtn;
